import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  otpRequestEmail,
  otpRequestMobile,
  otpVerifyEmail,
  otpVerifyMobile,
} from "../../../data/ApiEndpoints";
import VerifyOTPMobile from "./VerifyOTPMobile";

const VerifyMobileEmail = (props) => {
  const dispatch = useDispatch();
  const timerIdRef = useRef(null);

  const {
    formValues,
    setFormValues,
    formErrors,
    setFormErrors,
    onChangeInput,
    userInfoData,
  } = props;

  const iniModValues = {
    isModOpen: false,
    modName: "",
    otp: "",
    timerCount: "",
    requestNumber: "",
    requestEmail: "",
    isMobileVerified: false,
    isEmailVerified: false,
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [mobileLoading, setMobileLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);

  const closeModValues = () => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: false,
      modName: "",
      otp: "",
      timerCount: "",
    }));
  };

  const validateForm = (fieldName) => {
    let errors = {};

    if (fieldName === "staffMobile") {
      if (!formValues.staffMobile) {
        errors.staffMobile = "Required!";
      } else if (!/^\d{10}$/.test(formValues.staffMobile)) {
        errors.staffMobile = "Must be exactly 10 digits!";
      }
    } else if (fieldName === "staffEmail") {
      if (!formValues.staffEmail) {
        errors.staffEmail = "Required!";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.staffEmail)) {
        errors.staffEmail = "Invalid email format!";
      } else if (formValues.staffEmail.endsWith("@yopmail.com")) {
        errors.staffEmail = "Yopmail is not allowed!";
      }
    }

    return errors;
  };

  const startTimer = () => {
    setModValues((prevs) => ({ ...prevs, timerCount: 60 }));

    if (timerIdRef.current) {
      clearInterval(timerIdRef.current);
    }

    timerIdRef.current = setInterval(() => {
      setModValues((prevs) => {
        if (prevs.timerCount > 0) {
          return { ...prevs, timerCount: prevs.timerCount - 1 };
        } else {
          clearInterval(timerIdRef.current);
          return prevs;
        }
      });
    }, 1000);
  };

  const handleRequestOTP = async (payload, apiEndoint, callFor, requestFor) => {
    const method = "POST";
    const endpoint = apiEndoint;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");

        if (callFor === "request-otp") {
          startTimer();
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            modName: requestFor,
            otp: "",
            requestNumber: formValues.staffMobile,
            requestEmail: formValues.staffEmail,
          }));
        } else if (callFor === "verify-otp") {
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: false,
            modName: "",
            otp: "",
            isMobileVerified:
              requestFor === "request-mobile-otp"
                ? true
                : prevs.isMobileVerified,
            isEmailVerified:
              requestFor === "request-email-otp" ? true : prevs.isEmailVerified,
          }));
        }
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
        setModValues((prevs) => ({
          ...prevs,
          otp: "",
        }));
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onClickFetchDetails = async (request) => {
    const errors = validateForm(
      request === "request-mobile-otp" ? "staffMobile" : "staffEmail"
    );
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const setLoading = request === "request-mobile-otp" ? setMobileLoading : setEmailLoading;
      setLoading(true);

      const payload = {
        mobile: request === "request-mobile-otp" ? formValues.staffMobile : "",
        email: request === "request-email-otp" ? formValues.staffEmail : "",
        otp_type: "both",
        sms: 1,
      };

      await handleRequestOTP(
        payload,
        request === "request-mobile-otp" ? otpRequestMobile : otpRequestEmail,
        "request-otp",
        request
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      formValues.staffMobile &&
      formValues.staffEmail &&
      modValues.isMobileVerified &&
      modValues.isEmailVerified
    ) {
      setFormValues((prevs) => ({
        ...prevs,
        isMobileEmailVerified: true,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        isMobileEmailVerified: false,
      }));
    }
  }, [
    formValues.staffMobile,
    formValues.staffEmail,
    modValues.isMobileVerified,
    modValues.isEmailVerified,
  ]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModValues}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <VerifyOTPMobile
          modValues={modValues}
          setModValues={setModValues}
          onClickResend={() => onClickFetchDetails(modValues.modName)}
          onClickSubmit={() => {
            const payload = {
              mobile:
                modValues.modName === "request-mobile-otp"
                  ? modValues.requestNumber
                  : "",
              email:
                modValues.modName === "request-email-otp"
                  ? modValues.requestEmail
                  : "",
              otp: modValues.otp,
              sms: 1,
            };

            handleRequestOTP(
              payload,
              modValues.modName === "request-mobile-otp"
                ? otpVerifyMobile
                : otpVerifyEmail,
              "verify-otp",
              modValues.modName
            );
          }}
          closeModValues={closeModValues}
        />
      </Modal>

      <div className="formInputBox">
        <label htmlFor="staffMobile" className="formInputLabel">
          mobile number <span className="required">*</span>
        </label>

        <div className="input-add-btn flexBetween">
          <input
            type="number"
            className={`formInput ${formErrors?.staffMobile ? "formError" : ""}`}
            placeholder="Enter Mobile Number"
            name="staffMobile"
            value={formValues.staffMobile}
            onChange={onChangeInput}
            disabled={modValues.isMobileVerified}
          />

          <button
            type="button"
            className="btn btn-dark black-btn"
            disabled={mobileLoading}
            onClick={() => {
              if (modValues.isMobileVerified) {
                setFormValues((prevs) => ({
                  ...prevs,
                  staffMobile: "",
                }));
                setModValues((prevs) => ({
                  ...prevs,
                  isMobileVerified: "",
                }));
              } else {
                onClickFetchDetails("request-mobile-otp");
              }
            }}
          >
            {mobileLoading ? (
              <span className="spinner-border spinner-border-sm" role="status" />
            ) : modValues.isMobileVerified ? "clear" : "verify"}
          </button>
        </div>

        {formErrors?.staffMobile ? (
          <span className="error-label">{formErrors.staffMobile || ""}</span>
        ) : null}
      </div>

      <div className="formInputBox">
        <label htmlFor="staffEmail" className="formInputLabel">
          email address <span className="required">*</span>
        </label>

        <div className="input-add-btn flexBetween">
          <input
            type="email"
            placeholder="Enter Email Address"
            className={`formInput ${formErrors?.staffEmail ? "formError" : ""}`}
            name="staffEmail"
            value={formValues.staffEmail}
            onChange={onChangeInput}
            disabled={modValues.isEmailVerified}
          />

          <button
            type="button"
            className="btn btn-dark black-btn"
            disabled={emailLoading}
            onClick={() => {
              if (modValues.isEmailVerified) {
                setFormValues((prevs) => ({
                  ...prevs,
                  staffEmail: "",
                }));
                setModValues((prevs) => ({
                  ...prevs,
                  isEmailVerified: "",
                }));
              } else {
                onClickFetchDetails("request-email-otp");
              }
            }}
          >
            {emailLoading ? (
              <span className="spinner-border spinner-border-sm" role="status" />
            ) : modValues.isEmailVerified ? "clear" : "verify"}
          </button>
        </div>

        {formErrors?.staffEmail ? (
          <span className="error-label">{formErrors.staffEmail || ""}</span>
        ) : null}
      </div>
    </>
  );
};

export default VerifyMobileEmail;
